import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-[#1a1a2e] to-[#2d2d44] text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Logo e Descrição */}
          <div className="lg:col-span-1">
            <img
              src="https://public.readdy.ai/ai/img_res/910f43ad-08c4-4642-880c-fa462147fbd8.png"
              alt="Carbone Soluções Financeiras"
              className="h-20 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              Especialistas em crédito consignado com atendimento humano, rápido e transparente para sua tranquilidade financeira.
            </p>
          </div>

          {/* Links Rápidos */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-[#d4af37]">Links Rápidos</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-[#d4af37] transition-colors text-sm">
                  Início
                </Link>
              </li>
              <li>
                <Link to="/quem-somos" className="text-gray-300 hover:text-[#d4af37] transition-colors text-sm">
                  Quem Somos
                </Link>
              </li>
              <li>
                <Link to="/produtos" className="text-gray-300 hover:text-[#d4af37] transition-colors text-sm">
                  Produtos
                </Link>
              </li>
              <li>
                <Link to="/contato" className="text-gray-300 hover:text-[#d4af37] transition-colors text-sm">
                  Contato
                </Link>
              </li>
            </ul>
          </div>

          {/* Serviços */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-[#d4af37]">Nossos Serviços</h3>
            <ul className="space-y-3">
              <li>
                <a href="/#inss" className="text-gray-300 hover:text-[#d4af37] transition-colors text-sm">
                  Crédito Consignado INSS
                </a>
              </li>
              <li>
                <a href="/#clt" className="text-gray-300 hover:text-[#d4af37] transition-colors text-sm">
                  Crédito Consignado CLT
                </a>
              </li>
              <li>
                <a href="/#portabilidade" className="text-gray-300 hover:text-[#d4af37] transition-colors text-sm">
                  Portabilidade
                </a>
              </li>
              <li>
                <a href="/#veiculos" className="text-gray-300 hover:text-[#d4af37] transition-colors text-sm">
                  Financiamento de Veículos
                </a>
              </li>
              <li>
                <a href="/#imoveis" className="text-gray-300 hover:text-[#d4af37] transition-colors text-sm">
                  Financiamento de Imóveis
                </a>
              </li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-[#d4af37]">Contato</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-[#d4af37] text-lg mt-1"></i>
                <div>
                  <a href="tel:+5519971344445" className="text-gray-300 hover:text-[#d4af37] transition-colors text-sm">
                    (19) 97134-4445
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-[#d4af37] text-lg mt-1"></i>
                <div>
                  <a href="mailto:contato@carbonesolucoesfinanceiras.com.br" className="text-gray-300 hover:text-[#d4af37] transition-colors text-sm break-all">
                    contato@carbonesolucoesfinanceiras.com.br
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-[#d4af37] text-lg mt-1"></i>
                <div>
                  <span className="text-gray-300 text-sm">Serra Negra, São Paulo</span>
                </div>
              </li>
            </ul>

            {/* Redes Sociais */}
            <div className="flex gap-3 mt-6">
              <a
                href="https://www.instagram.com/carbonesolucoesfinanceiras/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-[#d4af37] rounded-lg transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61586501853205"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-[#d4af37] rounded-lg transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="https://wa.me/5519971344445?text=Olá! Gostaria de falar com um especialista."
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-[#25D366] rounded-lg transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Linha Divisória */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} Carbone Soluções Financeiras. Todos os direitos reservados.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-[#d4af37] text-sm transition-colors"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
